module.exports = __webpack_public_path__ + "static/cellStyling-341f6242a569c3b19cbb69b5910a6ddb.gif";